<template>
  <div class="status-bar">
    <timeline-step status="cancelled" title="Application Cancelled">
      <template v-slot:caption>
        <div class="caption">
          <p>
            Your application has been cancelled. Thank you for giving us the opportunity to meet
            your education funding needs! If you would like to reapply click
            <a class="inline-link" :href="`${lenderUrl}`">here</a>. To speak with one of our support
            representatives, please contact us at
            <a class="inline-link" :href="`mailto:${emailAddress}`"> {{ emailAddress }}</a>
            or <a class="inline-link" :href="`tel:${hrefTFN}`">{{ tollFreeNumber }}</a
            >. Agents are available by phone 24 hours a day, 7 days a week.
          </p>
        </div></template
      >
    </timeline-step>
  </div>
</template>
<script setup lang="ts">
import { useStore } from "vuex";
import TimelineStep from "@/components/timeline/TimelineStep.vue";
import useApplicationStatus from "@/composables/application-status/useApplicationStatus";

useStore();

const { hrefTFN, tollFreeNumber, emailAddress, lenderUrl } = useApplicationStatus();
</script>
